exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".notfound {\n  font-size: 48px;\n  font-weight: bold; }\n", "", {"version":3,"sources":["/opt/build/repo/src/flows/NotFound/style.scss"],"names":[],"mappings":"AAEA;EACC,gBAAe;EACf,kBAAiB,EACjB","file":"style.scss","sourcesContent":["@import '~@/containers/App/styles/vars';\n\n.notfound {\n\tfont-size: 48px;\n\tfont-weight: bold;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--9-2!./node_modules/postcss-loader/lib??ref--9-3!./node_modules/sass-loader/lib/loader.js??ref--9-4!./src/flows/NotFound/style.scss
// module id = +J/p
// module chunks = 18